module.exports = __webpack_public_path__ + "img/Chang-Family-2020-Logo.fa2af97f.png";